<template>
  <div id="install">
    <h3>Installation</h3>
    <pre>npm install vue-sidebar-bootstrap</pre>
    Then:
    <div class="font-weight-bold">main.js</div>
    <pre>
      import VueSidebarBootstrap from 'vue-sidebar-bootstrap'
      ...
      Vue.use(VueSidebarBootstrap)
    </pre>

    After these steps you can use all the components (vsb-sidebar, vsb-layout)
    application-wide.
  </div>
</template>

<script>
export default {
  name: 'Install'
};
</script>

<style></style>
